import React from 'react'
import { NavLink,Link , useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import { FaWhatsapp, FaInstagram, FaTwitter, FaFacebook, FaRegEnvelope } from "react-icons/fa";
import BackArrow from "../components/BackArrow";
import { useState, useEffect } from "react";
import toast from "react-hot-toast";
import { useLocation } from "react-router-dom";

const Foot = () => {
  const [categories, setCategories] = useState([]);
  const location = useLocation();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_SERVER_DOMAIN}/api/products/categories`);
        const result = await res.json();
        setCategories(result);
      } catch (error) {
        toast.error("Failed to load categories");
      }
    };
    fetchCategories();
  }, []);

  return (
    <Wrapper>

    <footer className="container">
      <div className="footerUpper">     
        <div className="footerLogo">
          <img src="./images/cianalogo.jpg" alt="Ciana Logo"/>
        </div>
        
        <nav className="footerInformation">
          <h3>Learn more</h3>
          <div className="footerLink">
            <NavLink to="/">Home</NavLink>
            <NavLink to="/about">About Us</NavLink>
            <NavLink to="/contact">Contact Us</NavLink>
            <NavLink to="/FAQ">FAQ's</NavLink>
          </div>
        </nav>
                  
        <nav className="footerCollection">
          <h3>Collection</h3>
          <div className="footerCategory">
            {categories.map((cat) => (
              <NavLink
                key={cat._id}
                to={`/products?category=${cat._id}`}
                className={() =>
                  location.search === `?category=${cat._id}` ? "active" : ""
                }
              >
                {cat.label}
              </NavLink>
            ))}
          </div>
        </nav>
                  
        <div className="footerSocial">
          <h3>Call : +91 96648 36525</h3>
          <h3>Follow us</h3>
          <div className="footerSocialIcon">
            <FaWhatsapp aria-label="WhatsApp" className="icon" color="green"/>
            <FaInstagram aria-label="Instagram" className="icon" color="orange"/>
            <FaTwitter aria-label="Twitter" className="icon" color="skyblue"/>
            <FaFacebook aria-label="Facebook" className="icon" color="blue"/>
            <NavLink to="/contact">
            <FaRegEnvelope aria-label="Envelope" className="icon" color="grey" fontSize={"3rem"}/>
            </NavLink>
          </div>
          
           <address className="address">
              <hr/>
              <h3>Reg Office:</h3>
              CIANA HOME PRODUCTS LLP <br/> 
              602, Q- BLOCK, SHYAM HILLS, <br/>
              NEW RANIP AHMEDABAD-382470 <br/>
              GUJARAT (INDIA)
              <h3>e-mail: info@cianahome.com</h3>
          </address>
        </div>
      </div>
     <hr/>
        <div className="footerBottom">   
            <div>
              <p>Copyright © {new Date().getFullYear()}, Ciana Home Products llp.</p>
              <p>All rights reserved</p>
            </div>
            <div>
              <p><Link to="/privacy">Privacy Policy</Link></p>
              <p><Link to="/terms">Terms & Conditions</Link></p>
            </div>
        </div>
    </footer>
     <BackArrow/>
    </Wrapper>
  );
};

const Wrapper=styled.section`
  background-color:  ${({ theme }) => theme.colors.bgl};
 
 .footerUpper {
    display: grid;
    grid-template-columns: 1.5fr 2.75fr 2.75fr 3fr;
    gap: 2rem;
    padding: 2rem;
    }

  .footerLogo img {
    width: 12rem;
    height: 12rem;
    }

  .footerLink, .footerCategory {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1rem;
    font-size: 1.5rem;
    
    a {
      text-decoration: none;
      color: ${({ theme }) => theme.colors.font};
      font-size: 1.5rem;

        &:hover,
        &:focus,
        &.active 
        {color: rgb(32, 12, 250);
        }
      }  
  }

 
.footerSocialIcon {
    display: flex;
    gap: 1rem;
    margin-top: 1rem;
    justify-content: space-between;
    font-size: 3rem;}
    
  .address {
    margin-top: 2rem;
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.font};
    }

  .footerBottom {
    display: grid;
    grid-template-columns: 6fr 4fr;
    padding: 0 5rem;
   
    a, p{
      text-decoration: none;
      color: ${({ theme }) => theme.colors.font};
      font-size: 1.2rem;
      }
  }
   
@media (max-width: ${({ theme }) => theme.media.mobile}){
  
.footerUpper {
  display: grid;
  grid-template-columns: 2fr 4fr 4fr; 
  gap: 1rem;
  padding: 2rem;  
  }

.footerUpper > :nth-child(4) {
  grid-column: 1 / -1; 
  font-size: 1rem;
  border-top: 1px solid grey;  
  }

   
.footerBottom {
  padding: 0 1rem; 
  }

h3{
  margin-top: 0.75rem;
  font-size: 1.5rem;
  }

 .footerLink, .footerCategory {
  gap: 0.5rem;
    a {
      text-decoration: none;
       color: ${({ theme }) => theme.colors.font};
      font-size: 1.3rem;}
   }


  .footerBottom p, a{
    font-size: 1rem;
    }
  
   .footerLogo img {
    width: 10rem;
    height: 10rem;
    }
}
`;
export default Foot
